import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { Company } from '@mews-commander/data-access';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { ApplicationState, Customer } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { closeDialog } from '../../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../../modules/dialog/selectors';
import { FORM_NAME } from './constants';
import SendEmailDialogForm from './SendEmailDialogForm';

interface StateProps {
    active: boolean;
    company?: Company;
    customer?: Customer;
}

interface DispatchProps {
    onClose: () => void;
}

type SendEmailDialogProps = DispatchProps & StateProps;

const SendEmailDialog = ({ onClose, active, company, customer }: SendEmailDialogProps) => (
    <ConnectedEditDialogForm
        active={active}
        buttonsSize="medium"
        formName={FORM_NAME}
        primaryButtonTextKey={TextKey.Send}
        secondaryButtonTextKey={TextKey.Cancel}
        closeDialog={onClose}
        size="small"
        title={<LocalizedText textKey={TextKey.SendByEmail} />}
        floatingPanel
    >
        <SendEmailDialogForm type="SendBill" company={company} customer={customer} />
    </ConnectedEditDialogForm>
);

export default pipe(
    SendEmailDialog,
    connect<StateProps, DispatchProps, {}, ApplicationState>(
        (state) => ({
            active: isDialogOpen(state, { name: FORM_NAME }),
        }),
        (dispatch) => ({
            onClose: () => dispatch(closeDialog(FORM_NAME)),
        })
    )
);
